var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.688 12.25C4.688 6.002 9.752.937 16 .937c6.248 0 11.313 5.065 11.313 11.313 0 4.158-2.248 7.781-5.582 9.745a.113.113 0 00-.04.037.033.033 0 00-.003.008v3.273a2 2 0 01-2 2h-7.375a2 2 0 01-2-2V22.04a.033.033 0 00-.005-.008.113.113 0 00-.039-.037c-3.334-1.964-5.582-5.587-5.582-9.745zM16 2.937a9.313 9.313 0 00-9.313 9.313c0 3.418 1.845 6.4 4.597 8.022a2.061 2.061 0 011.028 1.768v3.273h7.376V22.04a2.06 2.06 0 011.028-1.768c2.752-1.621 4.596-4.604 4.596-8.022A9.313 9.313 0 0016 2.937zm-5.687 27.126a1 1 0 011-1h9.374a1 1 0 110 2h-9.375a1 1 0 01-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.668 11.543a1 1 0 011.414 0l2.105 2.105 1.752-1.752a1.5 1.5 0 012.122 0l1.752 1.752 2.105-2.105a1 1 0 011.414 1.414l-2.459 2.46a1.5 1.5 0 01-2.121 0L16 13.663l-1.752 1.752a1.5 1.5 0 01-2.121 0l-2.46-2.459a1 1 0 010-1.414z"
  })));
}

export default SvgLight;